module.exports = __webpack_public_path__ + "fa031849f7ea5fff58529e26c97b937d.png";